import { DateFormatEnum, formatStringToDate, isValidDate } from "@core/utils";
import { ValidationInputType } from "@generation/core";
import { AbstractValidation } from "@generation/form/src/Validations/AbstractValidation";
import { CustomErrorMessage } from "@generation/form/src/Validations/ValidationHelper";

export class DateNotInFutureValidation extends AbstractValidation {
  key = "isDateNotInFuture";
  constructor(private readonly required = true, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    if (!this.required && (value === "" || value === undefined || value === null)) {
      return true;
    }

    if (isValidDate(value as unknown as string, DateFormatEnum.Date)) {
      const date = formatStringToDate(value as unknown as string, DateFormatEnum.Date);
      return date < new Date();
    }
    return false;
  };

  defaultMessage = (label: string): string => `'${label}' is ongeldig`;
}
